

exports.__esModule = true;
exports.$xoLoginPageComponent = undefined;

var _angular = require('angular');

var _integration = require('js/lib/integration');

var _miniBrowser = require('js/lib/miniBrowser');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-device-info/dist/index');

var _kmliUpsell = require('xo-login-components/src/onetouch-interstitial/kmliUpsell');

var _index2 = require('xo-models/src/app/index');

var _index3 = require('xo-models/src/user/index');

var _auth = require('xo-models/src/auth');

var _index4 = require('xo-models/src/checkout/index');

var _index5 = require('xo-models/src/fi/index');

var _marketingoffer = require('xo-models/src/marketingoffer');

var _newMember = require('xo-models/src/newMember');

var _user = require('xo-models/src/user');

var _venmoModels = require('xo-third-party-components/src/venmo-models');

var _thirdPartyInfo = require('xo-third-party-components/src/thirdParty-info');

require('xo-title/dist/directive');

require('xo-form-components/src/language-options/directive');

require('xo-login-components/src/login/handler/directive');

require('xo-ui-components/src/card-loader/directive');

require('xo-ui-components/src/message/directive');

require('xo-page-components/src/value-props/directive');

require('xo-login-components/src/unified-login/directive');

var _utils = require('xo-member-components/src/vaulting/utils');

var _loginEligibility = require('./loginEligibility');

require('./onboarding/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./tokenized-wallet-loader/directive');

var _factory = require('./tokenized-wallet-loader/factory');

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoLoginPageComponent = exports.$xoLoginPageComponent = _squid.$Component.extend('$xoLoginPageComponent', {
    tag: 'xo-login-page',
    template: _template2['default'],
    scope: {
        token: '=?'
    },
    link: function link() {
        _logger.$logger.info('login_link');
    },
    lifecycle: {
        populate: function populate() {
            var $scope = this;

            (0, _squid.$populate)($scope, {
                checkoutAppData: _index4.$CheckoutAppDataModel.instance(_angular.$rootScope.token)
            });
        }
    },
    rootEvents: {
        allLoaded: function allLoaded() {
            if (!_integration.$integration.getConfig('ALLOW_AUTH')) {
                if (_integration.$integration.getConfig('CAN_FRAMEBUST')) {
                    return _miniBrowser.$miniBrowser.frameBust(this.props.token);
                } else {
                    throw _integration.$integration.error('Can not framebust');
                }
            }
        }
    },
    controller: ['$scope', function ($scope) {
        _logger.$logger.info('login_controller');

        var fptiHardErrors = ['RESTRICTED_USER', 'PAYEE_BLOCKED_TRANSACTION', 'PAYMENT_ALREADY_DONE', 'PAYMENT_DENIED', 'PAYEE_ACCOUNT_RESTRICTED', 'INVALID_RESOURCE_ID', 'EXPIRED_SESSION', 'PAYER_COUNTRY_NOT_ALLOWED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED'];

        var memberSegmentMapper = {
            NEW_MEMBER: 'NEW_XO_MEMBER',
            YOUNG_MEMBER: 'YOUNG_XO_MEMBER',
            EXISTING_MEMBER: 'EXISTING_XO_MEMBER'
        };

        var ROUTE_MAPPING = {
            ECONSENT_REQUIRED: 'checkout.econsent'
        };

        $scope.ulEligibility = false;
        $scope.isWalletTokenization = false;

        /* If we detect a back/forward button click to land on the app, do not auto-login. In this case, the buyer
         is attempting to navigate to a specific page, so we should not auto-redirect them.
          This also fixes an issue with users:
         - Authorizing the checkout session
         - Redirecting to the merchant
         - Hitting back and landing on login page
         - Calling create on checkout and overwriting the authorization
         - Hitting forward and landing again on merchant page
         */

        if (window.performance && window.performance.navigation && window.performance.navigation.type === 2) {
            _angular.$rootScope.forceLogin = true;
        }

        if (!_angular.$rootScope.forceLogin) {
            $scope.autoLogin = true;
        }

        _angular.$rootScope.forceLogin = true;
        $scope.hideGuest = _uiRouter.$stateParams.targetPage === 'PAYER_AUTHENTICATION_REQUIRED' || _uiRouter.$stateParams.showNotYou;
        $scope.promptlogin = $scope.hideGuest && !(0, _squid.$feature)('riskyLoginContingency');

        // log statement for mobile webview
        if (_index.$DeviceInfo.isApp()) {
            _logger.$logger.debug('HERMES_IN_MOBILE_WEBVIEW');
        }

        if (!_miniBrowser.$miniBrowser.isMiniBrowser() && _squid.$locale.country === 'BR') {
            var brPxp = _squid.$config.pxpExperiments.BR.xo_br_hermesnode_login_design;

            (0, _squid.$pxpFactors)(brPxp.pgName, brPxp.params, brPxp.pattern).then(function (result) {
                $scope.loginDesignExp = result;
            });
        }

        $scope.onContingency = function (name, contingency) {
            if (!ROUTE_MAPPING[name]) {
                throw new _squid.$FallbackError({
                    reason: name.toLowerCase(),
                    product: 'ux'
                });
            }

            _uiRouter.$state.go(ROUTE_MAPPING[name]);
        };

        $scope.checkoutSession = _index4.$CheckoutSessionModel.instance(_angular.$rootScope.token);
        $scope.eConsent = _user.$EConsentModel.instance(_angular.$rootScope.token);
        $scope.tokenizedWalletEligibility = _index2.$TokenizedWalletEligibilityModel.instance(_angular.$rootScope.token);
        $scope.userProductSubscription = _index3.$UserProductSubscriptionModel.instance();
        $scope.tokenizedWalletPin = _index2.$TokenizedWalletPinModel.instance(_angular.$rootScope.token);
        $scope.tokenizedWalletMsbOffer = _index2.$TokenizedWalletMsbOfferModel.instance(_angular.$rootScope.token);
        $scope.walletPreferences = _index5.$WalletPreferences.instance(_angular.$rootScope.token);
        $scope.memberSegment = _marketingoffer.$MemberSegmentModel.instance();
        $scope.dependencyEligibility = true;

        var isValidGamingContingencies = function isValidGamingContingencies(err) {
            // Map usRMG specific error cause to EOL message.
            var endOfLineErrorList = ['GAMER_INELIGIBLE', 'GAMER_FI_INELIGIBLE', 'GAMER_FI_UNCONFIRMED', 'GAMER_ACCOUNT_UNVERIFIED', 'GAMER_INVALID_ACCOUNT_TYPE', 'GAMER_LOGIN_OUT_OF_COUNTRY', 'GAMING_INVALID_PAYMENT_FLOW', 'GAMER_RESIDENCE_OUT_OF_COUNTRY', 'GAMER_NO_VALID_FUNDING_INSTRUMENT'];

            return err && err.cause && endOfLineErrorList.indexOf(err.cause) > -1;
        };

        var isUSGambling = function isUSGambling(_ref) {
            var err = _ref.err;

            var isUSBuyer = _squid.$locale.country === 'US';
            var isUSmerchant = $scope.checkoutAppData && $scope.checkoutAppData.get('merchant.merchant_country') === 'US';

            return isUSBuyer && isUSmerchant && $scope.checkoutPayeeModel.isGambling() && isValidGamingContingencies(err);
        };

        // preloading most popular routes where after setbuyer
        // we should keep the balance here to prevent over loading non needed javascript
        // basically the most popular routes should be added here
        var preloadCodeSplitRoutes = function preloadCodeSplitRoutes() {
            if (_squid.$meta.codeSplitting) {
                Promise.all([import('pages/xo-select-fi/route'), import('pages/xo-add-card/route')])['catch'](function (err) {
                    _logger.$logger.info('code_split_setbuyer_routes_preload_failed', {
                        error: err && err.message
                    });
                });
            }
        };

        $scope.setBuyer = function () {
            var fptiData = {
                from: 'CREATE_XO_SESSION',
                to: 'process_create_xo_session'
            };

            function handleContingency(name, err) {
                _logger.$logger.info('[xo login handleContingency]', {
                    name: name,
                    err: err
                });

                // Check if negative case has been previously handled.
                if (!$scope.dependencyEligibility) {
                    return;
                }

                var errorCode = err.cause || name;

                fptiData.int_error_code = errorCode;
                fptiData.error_source = 'paymentapiplatformserv';
                fptiData.error_type = fptiHardErrors.indexOf(errorCode) > -1 ? 'hard_decline' : 'soft_decline';
                _logger.$logger.info('checkout_fpti', fptiData);

                // NOTE: curently `GAMER_INELIGIBLE` is only designed for DE gambling
                // however, this new Contingency is expected to expand to all gambling
                // countries moving forward.
                if (isUSGambling({ err: err }) || errorCode === 'GAMER_INELIGIBLE') {
                    // US gambling buyer & merchant should get EOL
                    // for certain compliance Contingencies
                    return _uiRouter.$state.go('checkout.genericError', {
                        code: errorCode
                    });
                }

                if (name !== 'NEED_AUTHENTICATED_CARD') {
                    throw err;
                }

                // come from guest or have alternate FI options, go to review
                if (_squid.$util.param('redirectToHermesOnUpopCancel') === 'xoon' || err && err.resolution && err.resolution.data && err.resolution.data.alternate_options) {
                    _uiRouter.$state.go('checkout.review');
                } else {
                    // else go to addCard
                    _uiRouter.$state.go('checkout.updateCard.addCardFlow.addCard');
                }
            }

            function handleNoValidTopupFiContingency(name, err) {
                // Check if negative case has been previously handled.
                if (!$scope.dependencyEligibility) {
                    return;
                }
                if ($scope.isWalletTokenization) {
                    fptiData.int_error_code = err.cause;
                    fptiData.error_source = 'paymentapiplatformserv';
                    fptiData.error_type = fptiHardErrors.indexOf(err.cause) > -1 ? 'hard_decline' : 'soft_decline';
                    _logger.$logger.info('checkout_fpti', fptiData);
                    $scope.checkoutSession.contingency = name;

                    _factory.$TokenizedWalledLoaderFactory.goToTokenizationInfoPage();
                } else {
                    handleContingency(name, err);
                }
            }

            _logger.$logger.info('checkout_fpti', {
                from: 'CREATE_XO_SESSION',
                to: 'prepare_create_xo_session'
            });

            $scope.isWalletTokenization = $scope.checkoutCart.isWalletTokenization();

            if ($scope.isWalletTokenization) {
                _angular.$rootScope.$emit('allLoaded');
            }

            $scope.eConsent.retrieve({
                batch: {
                    name: 'setbuyer',
                    silent: $scope.isWalletTokenization,
                    id: 'eConsent',
                    dependencies: []
                },
                contingencies: {
                    ECONSENT_REQUIRED: function ECONSENT_REQUIRED(name, err) {
                        if ($scope.dependencyEligibility) {
                            $scope.dependencyEligibility = false;
                            _logger.$logger.debug('ULLOGIN_ECONSENT_REQUIRED');
                            _uiRouter.$state.go('checkout.econsent');
                        }
                    }
                }
            });

            if ($scope.isWalletTokenization) {
                // these params are coming from Mayfly (see xo-hermes-app/apis/tokenizedWalletInfo)
                var _$scope$tokenizedWall = $scope.tokenizedWalletInfoModel,
                    wallet_id = _$scope$tokenizedWall.wallet_id,
                    external_device_id = _$scope$tokenizedWall.external_device_id,
                    tr_client_id = _$scope$tokenizedWall.tr_client_id,
                    product_name = _$scope$tokenizedWall.product_name;

                var subject = $scope.tokenizedWalletInfoModel.getSubject();

                // TODO: move to TokenizedWalletInfoModel
                var WALLET_BRANDS = {
                    'google': 'APAY',
                    'Samsung': 'SAMSUNGPAY'
                };

                var params = {
                    wallet_brand: WALLET_BRANDS[subject],
                    tenant_id: 'Hermes',
                    wallet_id: wallet_id,
                    external_device_id: external_device_id,
                    subject: subject,
                    tr_client_id: tr_client_id,
                    product_name: product_name
                };

                if (_squid.$meta.query && _squid.$meta.query.wallet_id) {
                    params.wallet_id = _squid.$meta.query.wallet_id;
                }
                if (_squid.$meta.query && _squid.$meta.query.jwt) {
                    params.jwt = _squid.$meta.query.jwt;
                }

                $scope.tokenizedWalletEligibility.retrieve({
                    params: params,
                    batch: {
                        name: 'setbuyer',
                        id: 'tokenizedWalletLightEligibility',
                        silent: $scope.isWalletTokenization,
                        dependencies: ['eConsent']
                    },
                    success: function success(result) {
                        if (!result.eligible) {
                            var msg = 'tokenized_wallet_ineligible_for_provisioning';

                            _logger.$logger.info(msg);

                            if ($scope.dependencyEligibility) {
                                $scope.dependencyEligibility = false;
                                var code = void 0;

                                fptiData.int_error_code = result.reason;
                                fptiData.error_source = 'paymenttokenserv';
                                fptiData.error_type = 'hard_decline';
                                _logger.$logger.info('checkout_fpti', fptiData);

                                switch (result.reason) {
                                    case 'WALLET_ID_ALREADY_PROVISIONED':
                                        code = 'ANDROID_PAY_ALREADY_PROVISIONED';
                                        break;

                                    case 'COUNTRY_NOT_SUPPORTED':
                                        code = 'ANDROID_PAY_COUNTRY_NOT_SUPPORTED';
                                        break;

                                    default:
                                        code = 'ANDROID_PAY_ELIGIBILITY_ERROR';
                                        break;
                                }
                                code = window.btoa(code);

                                _uiRouter.$state.go('checkout.genericError', { code: code });
                            }
                        }
                    }
                });

                // check we have product provision subscribed by buyer
                // if not subscribed redirect to splash screen of subscription upsell
                $scope.userProductSubscription.retrieve({
                    batch: {
                        name: 'setbuyer',
                        id: 'userProductSubscription',
                        silent: $scope.isWalletTokenization,
                        dependencies: ['eConsent', 'tokenizedWalletLightEligibility']
                    },

                    success: function success(result) {
                        // result is going to an object of { applicable: true, subscribed: true, reason: 'PAYPAL_CASH' }
                        if (result.applicable && !result.subscribed) {
                            _logger.$logger.info('product_subscription_enabled_not_subscribed');
                            $scope.dependencyEligibility = false;
                            _uiRouter.$state.go('checkout.cipverification');
                        }
                    }
                });

                $scope.tokenizedWalletPin.retrieve({
                    batch: {
                        name: 'setbuyer',
                        id: 'tokenizedWalletPin',
                        silent: $scope.isWalletTokenization,
                        dependencies: ['eConsent']
                    },
                    success: function success(result) {
                        if (result.pinId) {
                            _logger.$logger.info('tokenized_wallet_get_pin_set', {
                                pinOrigin: result.pinOrigin,
                                pinId: result.pinId
                            });
                        } else {
                            _logger.$logger.info('tokenized_wallet_get_pin_not_set', {
                                pinKey: result.suggestedKey ? result.suggestedKey : 'unavailable'
                            });
                        }
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name, err) {
                            _logger.$logger.info('tokenized_wallet_get_pin_error');
                            return _uiRouter.$state.go('checkout.genericError', { code: 'DEFAULT' });
                        }
                    }
                });

                $scope.tokenizedWalletMsbOffer.retrieve({
                    params: {
                        tokenizedWalletToken: $scope.checkoutCart.tokenizedWalletToken
                    },
                    batch: {
                        name: 'setbuyer',
                        id: 'tokenizedWalletMsbOffer',
                        silent: $scope.isWalletTokenization,
                        dependencies: ['eConsent']
                    },
                    success: function success(result) {
                        var msg = 'tokenized_wallet_msb_offer';

                        if (result && result.enabled) {
                            _logger.$logger.info(msg + '_enabled', result);
                        } else {
                            _logger.$logger.info(msg + '_disabled');
                        }
                    }
                });
            }

            if (_squid.$config.enableNewMemberDecisioning) {
                _logger.$logger.info('checkout_fpti', {
                    from: 'CEP_decisioning',
                    to: 'prepare_cep_descisioning'
                });

                $scope.memberSegment.save({
                    data: $scope.memberSegmentData,
                    batch: {
                        name: 'setbuyer',
                        id: 'memberSegment',
                        silent: true,
                        dependencies: $scope.ulEligibility ? ['securityCtx'] : []
                    },
                    success: function success(result) {
                        var memberSegment = memberSegmentMapper[result.memberSegment] || result.memberSegment;

                        _logger.$logger.info('cep_member_decisioning_success', {
                            segment: memberSegment,
                            creditOffer: result.creditOffer
                        });
                        _logger.$logger.info('checkout_fpti', {
                            from: 'CEP_decisioning',
                            to: 'process_cep_descisioning',
                            cep_response: memberSegment + ':' + result.creditOffer
                        });
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name, err) {
                            _logger.$logger.info('cep_member_decisioning_failed');
                            _logger.$logger.info('checkout_fpti', {
                                from: 'CEP_decisioning',
                                to: 'process_cep_descisioning',
                                int_error_code: 'SERVICE_ERROR',
                                error_source: 'marketingofferreadserv',
                                error_type: 'soft_decline'
                            });
                        }
                    }
                });
            }

            var isPayPalCredit = $scope.checkoutAppData.isSecondButton();

            $scope.checkoutSession.action('create', {
                data: {
                    preselected_fi_type: isPayPalCredit ? 'credit' : undefined,
                    // user_selected_funding_source is referenced by xo-hermes-checkout, where it retrieves the product_name in it and passes it to the CreateXO api.
                    user_selected_funding_source: $scope.userSelectedFundingSource,
                    clear_installments: true
                },
                batch: {
                    name: 'setbuyer',
                    id: 'createCheckoutSession',
                    silent: $scope.isWalletTokenization,
                    dependencies: !$scope.isWalletTokenization ? ['eConsent'] : ['eConsent', 'tokenizedWalletLightEligibility', 'userProductSubscription', 'tokenizedWalletPin', 'tokenizedWalletMsbOffer']
                },
                success: function success(result) {
                    fptiData.available_plan_count = $scope.checkoutSession.getPlanList() ? $scope.checkoutSession.getPlanList().length : '0';
                    _logger.$logger.info('checkout_fpti', fptiData);

                    if (!$scope.dependencyEligibility) {
                        return;
                    }

                    if ($scope.auth.password_less && $scope.checkoutCart.isBilling()) {
                        if ((0, _squid.$feature)('pomaPasswordRecovery')) {
                            _uiRouter.$state.go('checkout.createPassword', { targetPage: 'BILLING_AGREEMENTS' });
                        }
                        return;
                    }

                    if (isPayPalCredit) {
                        return _util.$capeRedirectUtil.handleCapeRouting(result, $scope.checkoutCart, _angular.$rootScope.token);
                    }

                    if ($scope.isWalletTokenization) {
                        // no need to check upsell for wallet tokenization flows
                        // just set planDone prop for "<tokenized-wallet-loader>" component
                        $scope.planDone = true;
                        return;
                    }

                    return _kmliUpsell.$KmliUpsell.eligible(_angular.$rootScope.token).then(function (eligibility) {
                        var isEligible = eligibility && eligibility.interstitial ? eligibility.interstitial : {};

                        if (isEligible.eligible) {
                            var stateName = isEligible.type === 'member' ? 'KMLI_UPSELL' : 'KMLI_reactivation';

                            _logger.$logger.info('checkout_fpti', {
                                from: stateName,
                                to: 'prepare_kmli_upsell'
                            });

                            _logger.$logger.info('ryi_optin', {
                                'from': 'OT_Toggle',
                                'to': 'prepare_inter_optin'
                            });
                            return _uiRouter.$state.go('checkout.oneTouchUpsell', { oneTouchFlowName: 'checkout' });
                        }

                        if ($scope.auth.rtExchanged && (0, _squid.$feature)('rmSpinnerText')) {
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['login.loggedInWithOneTouch']
                            };
                        }

                        if ($scope.checkoutSession.negBals) {
                            return _uiRouter.$state.go('checkout.negativeBalanceRecovery');
                        } else {
                            (0, _utils.checkVaultingEligibility)().then(function (eligible) {
                                if (eligible) {
                                    (0, _utils.authorize)($scope.checkoutSession, $scope.checkoutAppData).then(function (authorizePage) {
                                        return _uiRouter.$state.go(authorizePage);
                                    })['catch'](function (err) {
                                        // eslint-disable-line handle-callback-err
                                        _uiRouter.$state.go('checkout.review');
                                    });
                                } else {
                                    _uiRouter.$state.go('checkout.review');
                                }
                            });
                        }
                    });
                },
                contingencies: {
                    // override contingency.js handler with custom logic to support both xoon/hermes flows
                    NEED_DEBIT_CARD: handleNoValidTopupFiContingency,
                    EXPIRED_DEBIT_CARD: handleNoValidTopupFiContingency,
                    DEFAULT: handleContingency
                }
            })['finally'](function () {
                // selectedInstallmentsData does not come from checkoutSession response from PAPS, so we need to keep track of this state ourselves.
                // We pass clear_installments when calling the checkout session API, so we need to reflect that this is being cleared.
                // See https://engineering.paypalcorp.com/jira/browse/PPPLMER-58580
                delete $scope.checkoutSession.selectedInstallmentData;
            });

            preloadCodeSplitRoutes();
        };

        /**
         * This call is made after the buyer is logged in, and before the CreateXO api call.
         * So that we can retrieve the tokenized funding capabilities for the buyer country.
         */
        $scope.getTokenizedFundingCapabilities = function () {
            return _index2.$TokenizedFundingCapabilitiesModel.instance(_angular.$rootScope.token).retrieve({
                params: {
                    tokenizedWalletToken: $scope.checkoutCart.tokenizedWalletToken,
                    country: $scope.auth.country
                }
            }).then(function (result) {
                if (result.isDirectFundingEnabled()) {
                    $scope.userSelectedFundingSource = {
                        product_name: result.getProductName()
                    };
                }
            });
        };

        $scope.preSetBuyerCalls = function () {
            var apiCalls = [];

            if ($scope.checkoutCart.isWalletTokenization()) {
                apiCalls.push($scope.getTokenizedFundingCapabilities());
            }
            return _angular.$q.all(apiCalls);
        };

        // Sorry for the indirection here.  There's postAuth, so "preAuth" compliments it well (easier on the brain)
        $scope.preAuth = function () {
            if ($scope.ulEligibility) {
                // For UL, batch up eConsent, xoSession
                $scope.preSetBuyerCalls().then(function () {
                    return $scope.setBuyer();
                });
            }
        };

        $scope.onSuccess = function () {
            if ($scope.ulEligibility) {
                // If the experiment is enabled, we already have what we need, so /quit.
                return;
            }
            $scope.preSetBuyerCalls().then(function () {
                return $scope.setBuyer();
            });
        };

        (0, _squid.$populate)($scope, {
            flowEligibility: _index4.$FlowEligibilityModel.instance(_angular.$rootScope.token).retrieve({
                params: {
                    geolocation: _squid.$meta.geolocation,
                    localeCountry: _squid.$locale.country // We need this till we completely migrate to server side locale resolution
                }
            }),
            auth: _auth.$AuthModel.instance(),
            checkoutAppData: _index4.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
            checkoutCart: _index4.$CheckoutCartModel.instance(_angular.$rootScope.token),
            checkoutPayeeModel: _index4.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
            tokenizedWalletInfoModel: _index2.$TokenizedWalletInfoModel.instance(_angular.$rootScope.token).retrieve(),
            venmoEligibility: _venmoModels.$VenmoTransactionEligibility.instance(_angular.$rootScope.token).retrieve({
                params: {
                    braintreeInegration: _squid.$util.param('bt_int_type') === '2' ? 'SFAuthSession' : '',
                    fundingSource: _squid.$util.param('fundingSource'),
                    localeCountry: _squid.$locale.country,
                    venmoOverride: _squid.$util.param('venmoOverride'),
                    native_xo: _squid.$util.param('native_xo')
                }
            })
        }).then(function () {
            return _newMember.$NewMemberEligibility.instance().getMemberSegmentParameters(_angular.$rootScope.token).then(function (data) {
                $scope.memberSegmentData = data;
                // Set flag to indicate all data is loaded
                $scope.populateComplete = true;
                return;
            });
        }).then(function () {
            // If the refresh token is present, the one touch experience must be preserved and the user must not
            // be presented with the venmo experience
            if (!$scope.auth.refresh_token) {
                var merchant_name = $scope.checkoutAppData.merchant.brand_name || $scope.checkoutAppData.merchant.merchant_name || $scope.checkoutAppData.merchant.merchant_email;

                $scope.infoVenmo = {
                    msgs: [(0, _squid.$renderContent)('landing.venmoAvailableSoon', { 'merchant': merchant_name })],
                    type: 'info'
                };

                var venmoPayloadID = window.xprops && window.xprops.venmoPayloadID;

                // if nativeSDK and SPB prop for payload_id exists, we go directly to venmo directive
                if (!_uiRouter.$stateParams.venmoError && $scope.venmoEligibility.venmo && venmoPayloadID) {

                    return _uiRouter.$state.go('checkout.venmo', { payload_id: venmoPayloadID });
                }

                if (!_uiRouter.$stateParams.venmoError && $scope.venmoEligibility.venmo) {
                    return _uiRouter.$state.go('checkout.payWithSelection');
                } else if (!_uiRouter.$stateParams.venmoError && _thirdPartyInfo.thirdPartyInfo.isVenmoCookiePresent()) {
                    $scope.showVenmoAvailableSoonMsg = true;
                }

                if (_uiRouter.$stateParams.venmoError && _squid.$util.param('marketplaces_venmo_client') === '1') {
                    return _uiRouter.$state.go('checkout.genericError', { code: 'VENMO_ERROR_WITH_CANCEL_URL' });
                }

                // Baidu eligibility checks. Pending pxp throttle
                return _thirdPartyInfo.thirdPartyInfo.isBaiduEligible().then(function (baiduEligible) {
                    if (!_uiRouter.$stateParams.baiduError && baiduEligible) {
                        return (0, _squid.$pxp)('xo_hermesnode_baidu', {
                            'ctx.COUNTRY': $scope.checkoutAppData.get('merchant.merchant_country'),
                            'uid': $scope.checkoutPayeeModel.getId()
                        }, '(xo_hermesnodeweb_baidu)(.*)').then(function (result) {
                            if (result && result.treatment_name === 'xo_hermesnodeweb_baidu_treatment_4660') {
                                return _uiRouter.$state.go('checkout.payWithSelection');
                            }
                        });
                    }
                });
            }
            if ($scope.flowEligibility.guest) {
                return;
            }

            $('.paypalHeaderWrapper').removeClass('paypalCredit');
            $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
        }).then(function () {
            var initKmliAndDeleteAT = function initKmliAndDeleteAT() {
                delete $scope.auth.access_token;
                _kmliUpsell.$KmliUpsell.init({});
            };

            // reload auth model for use cases where user is not logged in and access_token is in the hash
            // happens already in the middleware
            // basically if there is a param "euat" - there will be access token in the hash
            // otherwise I don't think we need to reload Auth model if user is logged in already
            if ($scope.auth.accessToken() && !$scope.auth.loggedIn()) {
                return $scope.auth.reload({
                    headers: {
                        'x-paypal-internal-euat': $scope.auth.accessToken()
                    },
                    resultModel: $scope.auth,
                    success: function success() {
                        initKmliAndDeleteAT();
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name) {
                            throw new _squid.$FallbackError({
                                reason: name.toLowerCase(),
                                product: 'ux'
                            });
                        }
                    }
                });
            } else if ($scope.auth.loggedIn()) {
                initKmliAndDeleteAT();
            }
        }).then(function () {
            return (0, _loginEligibility.$loginEligibility)(_angular.$rootScope.token, !$scope.autoLogin).then(function (result) {
                if (result === 'unifiedLogin') {
                    $scope.ulEligibility = true;
                } else if (result === 'apsIntegration') {
                    $scope.apsIntegration = 'apsIntegration';
                } else if (result === 'apsIntegrationRM') {
                    $scope.apsIntegration = 'apsIntegrationRM';
                }
            }).then(function () {
                var reinitDisplay = function reinitDisplay() {
                    $scope.promptlogin = false;
                    $scope.hideGuest = false;
                    $scope.autoLogin = true;
                    delete _uiRouter.$stateParams.targetPage;
                    delete _uiRouter.$stateParams.showNotYou;
                };

                $scope.logout = $scope.promptlogin ? function () {
                    _logger.$logger.info('not_you_logout');
                    _logger.$logger.info('checkout_fpti', {
                        from: 'LOGIN_UL',
                        to: 'login_with_diff_user'
                    });
                    $scope.auth.logoutAndRedirect('NOT_YOU');
                } : function () {
                    _logger.$logger.info('logout_switch_display');
                    reinitDisplay();
                };
            });
        });
    }]
});

angular.value("$xoLoginPageComponent", $xoLoginPageComponent);
_angular.$q;

_angular.$rootScope;

_integration.$integration;

_miniBrowser.$miniBrowser;

_squid.$Component;

_squid.$config;

_squid.$FallbackError;

_squid.$feature;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_squid.$pxp;

_squid.$pxpFactors;

_squid.$renderContent;

_squid.$util;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_index.$DeviceInfo;

_kmliUpsell.$KmliUpsell;

_index2.$TokenizedFundingCapabilitiesModel;

_index2.$TokenizedWalletEligibilityModel;

_index2.$TokenizedWalletInfoModel;

_index2.$TokenizedWalletMsbOfferModel;

_index2.$TokenizedWalletPinModel;

_index3.$UserProductSubscriptionModel;

_auth.$AuthModel;

_index4.$CheckoutAppDataModel;

_index4.$CheckoutCartModel;

_index4.$CheckoutPayeeModel;

_index4.$CheckoutSessionModel;

_index4.$FlowEligibilityModel;

_index5.$WalletPreferences;

_marketingoffer.$MemberSegmentModel;

_newMember.$NewMemberEligibility;

_user.$EConsentModel;

_venmoModels.$VenmoTransactionEligibility;

_thirdPartyInfo.thirdPartyInfo;

_utils.checkVaultingEligibility;

_utils.authorize;

_loginEligibility.$loginEligibility;

_factory.$TokenizedWalledLoaderFactory;

_util.$capeRedirectUtil;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-login/directive.js
// module id = ./pages/xo-login/directive.js
// module chunks = 0